import { AXIOS_INSTANCE } from "../../../config.js";

export const setCurrentBranch = (branch) => {
  return (dispatch) => {
    return AXIOS_INSTANCE.request({
      url: "/api/users/branch-selected",
      method: "POST",
      params: {
        branch_code: branch,
      },
    });
  };
};
